var styles = {"outerContainer":"FdrCrossSellHeader-module_outerContainer__-MyNh","container":"FdrCrossSellHeader-module_container__Fw6PK","menuItem":"FdrCrossSellHeader-module_menuItem__lpbQA","active":"FdrCrossSellHeader-module_active__z9uiL","icon":"FdrCrossSellHeader-module_icon__4ywgh","alert":"FdrCrossSellHeader-module_alert__52y4a"};

export { styles as default };
//# sourceMappingURL=FdrCrossSellHeader.module.scss.js.map
